import { toPng } from "html-to-image";
import { sanitizeFilename } from "src/utils/helper/charts/helper";

/**
 * Captures an HTML element (including its children, CSS styles, and any
 * embedded SVGs) and triggers a browser download as a high-resolution PNG.
 *
 * PNG at 2× pixel density is the right format here because the figure
 * consists of mixed content — HTML (patient count, cohort label) together
 * with SVG charts and a React-rendered pie chart — which cannot be
 * faithfully serialised to a pure SVG file. The 2× scale ensures the
 * output looks crisp on high-DPI (retina) displays and in print.
 */
export const downloadElement = async (
  element: HTMLElement,
  filename: string
): Promise<void> => {
  const dataUrl = await toPng(element, {
    pixelRatio: 2,
    cacheBust: true,
  });

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `${sanitizeFilename(filename, "chart")}.png`;
  document.body.appendChild(link);
  link.click();
  // Defer cleanup to mirror the CSV helper and give the browser time to
  // start the download before the anchor is removed.
  window.setTimeout(() => {
    link.remove();
  }, 0);
};
